import "./App.css";
import { Route, Switch } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { LandingPage } from "./Pages/LandingPage";
import { Theme } from "./theme";
import { VideoPage } from "./Pages/VideoPage";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateAdapter from "@mui/lab/AdapterDateFns";

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <Switch>
        <LocalizationProvider dateAdapter={DateAdapter}>
          <Route exact path="/" component={LandingPage} />
          <Route path="/video/:id" component={VideoPage} />
        </LocalizationProvider>
      </Switch>
    </ThemeProvider>
  );
}

export default App;
